<template>
  <div class="col-12 form-group px-4 pt-3 pb-3 pb-sm-0">
    <label class="form-control-label">Porcentagem das marcas</label><br>
    <div 
      class="row justify-content-md-start"
    >
      <div 
        class="col-12 col-sm-5 pt-1 pb-4"
        style="text-align:left;">
        <base-button @click="addBrandCopyConfiguration" type="success">nova porcentagem</base-button>
      </div>
    </div>
    <div
      class="row justify-content-md-start" 
      v-for="(brandCopyConfig, index) in brandCopyConfigs"
    >
      <div class="col-12 col-sm-4 pt-1">
        <el-select
          v-model="brandCopyConfig.brand_ids"
          filterable
          placeholder="Selecione um ou mais segmentos"
          multiple 
          remote 
          collapse-tags
          :key="index + 'select'"
        >
          <el-option 
            v-for="brand in brands" 
            :key="brand.id + selectedBrands.includes(brand.id).toString()" 
            :label="brand.name" 
            :value="brand.id"
          />
        </el-select>
      </div>
      <div class="col-12 col-sm-3 pt-1">
        <base-input
          :value="brandCopyConfig.percentage"
          @input="updateCopyPercentage(index, $event)"
          placeholder="Porcentagem sobre o volume da meta"
          aria-label="Porcentagem sobre o volume da meta"
          append-icon="fa fa-percent"
          mask="volume"
        ></base-input>
      </div>
      <div class="col-12 col-sm-3 pt-1">
        <multiselect
          v-model="brandCopyConfig.copy_stategy"
          :options="percentageOptions"
          label="label"
          track-by="value"
          :allow-empty="false"
          select-label=""
          deselect-label=""
          placeholder="Selecionar"
          selected-label=""
        />
      </div>
      <div 
        class="col-12 col-sm-2 pt-1"
        style="text-align:center;">
        <base-button @click="() => {destroyBrandCopyConfiguration(index)}" type="success">excluir</base-button>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import { Select, Option } from "element-ui";


export default {
  name: 'anosafra-brand-percentages',
  props: {
    value: {
      type: Array,
    },
  },
  components: {
    Multiselect,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data: () => ({
    percentageOptions: [
      { value: 'add',    label: 'Acréscimo' },
      { value: 'remove', label: 'Decréscimo' }
    ],
    brands: [],
    brandCopyConfigs: [],
  }),
  mounted() {
    if (this.brandCopyConfigurationsAttributes.length === 0) {
      this.addBrandCopyConfiguration()
    }

    this.getBrands()
  },
  computed: {
    brandCopyConfigurationsAttributes: {
      get() {
        return (this.value || [])
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    selectedBrands() {
      return this.brandCopyConfigs.map(bcc => bcc.brand_ids).flat(1).filter(el => el)
    }
  },
  methods: {
    async getBrands() {
      const response = await this.$http.secured.get(`/api/v1/brands`, { params: {
        name_only: true,
      }})

      this.brands = response.data
    },
    async destroyBrandCopyConfiguration(index) {
      const fireResult = await swal.fire({
        title: 'Você tem certeza ?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Tenho Certeza!'
      })

      if(!fireResult.isConfirmed){
        return
      }
      
      this.brandCopyConfigs.splice(index, 1)
    },
    addBrandCopyConfiguration() {
      this.brandCopyConfigs.push({
        percentage: 0, brands: [], copy_percentage: 0, copy_stategy: { value: 'add', label: 'Acréscimo' }
      })
    },
    updateBrandConfigBrands(index, value) {
      this.$set(this.brandCopyConfigs[index], 'brand_ids', value)
    },
    updateCopyPercentage(index, value) {
      this.$set(this.brandCopyConfigs[index], 'percentage', value)
      const copy_percentage = this.brandCopyConfigs[index].copy_stategy && 
        this.brandCopyConfigs[index].copy_stategy.value == 'remove' ?
          100 - parseFloat(value) :
          100 + parseFloat(value)

      this.$set(this.brandCopyConfigs[index], 'copy_percentage', copy_percentage)
    }
  },
  watch: {
    brandCopyConfigs(value) {
      this.brandCopyConfigurationsAttributes = value
    },
  }
}
</script>